export default __webpack_public_path__ + "static/media/empty-data-1.3357362b.svg";